/**
 * Lesotho loti.
 */
export var LSL = {
  code: 'LSL',
  base: 10,
  exponent: 2
};